<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div *ngFor="let item of objectItem.value | keyvalue : noSort">
  <div [ngSwitch]="item.value['type']">
    <div *ngSwitchCase="TaskDatumType.STRING" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-string-item [stringItem]="item.value" class="object-item"></app-string-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.TIMESTAMP_ISO" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-timestamp-item [timestampItem]="item.value" class="object-item"></app-timestamp-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.INT" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-int-item [intItem]="item.value" class="object-item"></app-int-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.DOUBLE" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-double-item [doubleItem]="item.value" class="object-item"></app-double-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.BOOL" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-boolean-item [booleanItem]="item.value" class="object-item"></app-boolean-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.ARRAY" fxLayout="column">
      <span>{{ item.key }}</span>
      <app-array-item [arrayItem]="item.value" class="object-item"></app-array-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.EXTENDED_IMAGE" fxLayout="column">
      <app-extended-image-item></app-extended-image-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.IMAGE_JPEG" fxLayout="column">
      <app-image-item
        [imageItem]="item.value"
        class="object-item"
        *ngIf="item.value['value'].length > 0"
      ></app-image-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.IMAGE_PNG" fxLayout="column">
      <app-image-item
        [imageItem]="item.value"
        class="object-item"
        *ngIf="item.value['value'].length > 0"
      ></app-image-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.IMAGE_URL">
      <app-image-url-item
        [imageItem]="item.value"
        class="object-item"
        *ngIf="item.value['value'].length > 0"
      ></app-image-url-item>
    </div>
    <div *ngSwitchCase="TaskDatumType.SIGNATURE">
      <app-signature-item [signatureItem]="item.value" class="object-item"></app-signature-item>
    </div>

    <div *ngSwitchCase="TaskDatumType.OBJECT" fxLayout="column">
      <app-object-item [objectItem]="item.value" class="object-item"></app-object-item>
    </div>
    <div *ngSwitchDefault fxLayout="column">
      <span>item not yet implemented object: </span>
      <span>type test: {{ item.key }}</span>
      <span>value : {{ item.value }}</span>
    </div>
  </div>
</div>
